<template>
  <div class="big-stavka-wrapper breakdown-stavka">
    <v-dialog v-model="delete_modal" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          {{ $t('office_management.purchase.delete_confirm') }}
        </div>
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
          <div
            class="universal-vdialog-button vbutton-secondary"
            @click="delete_modal = false"
          >
            {{ $t("repetitive.cancel") }}
          </div>
          <div
            class="universal-vdialog-button vbutton-primary"
            @click="deleteRow()"
          >
            {{ $t("page_2.page_2_3.delete_pop.btn_2") }}
          </div>
        </div>
      </v-card>
    </v-dialog>
    <div class="troskovnik-element-title">{{ $t('office_management.purchase.items') }}</div>
    <div class="troskovnik-stavke-wrapper group-wrapper purchase-table">
      <div class="fiksne-stavke-header">
        <div class="st bd1">{{ $t('components.general.office_management.purchase_table.name') }}</div>
        <div class="st bd2">{{ $t('components.general.office_management.purchase_table.description') }}</div>
        <div class="st bd3a">{{ $t('components.general.office_management.purchase_table.quantity') }}</div>
        <div class="st bd4">{{ $t('components.general.office_management.purchase_table.assigned_person') }}</div>
      </div>

      <div class="stavke-wrapper breakdown-wrapper purchase"  >
        <div class="stavke-row" v-for="(stavka, key) in stavke" :key="key"  :id="'purchase'+stavka.id">
          <div class="wrapp-checkbox">
            <div class="planer-mark-txt">
              <svg
                class="update-event-spin popup-event-spin"
                viewBox="0 0 50 50"
                style="display: none"
              >
                <circle
                  class="path"
                  cx="25"
                  cy="25"
                  r="20"
                  fill="none"
                  stroke-width="8"
                ></circle>
              </svg>

              <div
                :class="['task-checkbox', 'popup-check', stavka.aquired ? 'active' : '']"
                @click="purchaseValSwitch(stavka, key)"
              >
                <div class="check"></div>
              </div>
            </div>
          </div>
          <div :class="['fiksna-stavka', stavka.aquired ? 'done':'']" >
            <div :class="[stavka.aquired ? 'striketrough' : '']"></div>

            <div class="st bd1">{{ stavka.title }}</div>
            <div class="st bd2">{{ stavka.description }}</div>
            <div class="st bd3">{{ stavka.quantity }}</div>
            <div class="st bd4">{{stavka.odvjetnik ? stavka.odvjetnik.ime + " " + stavka.odvjetnik.prezime : "-"}}</div>
          </div>
          <div class="add-napomena add-button edit-item" @click="popEditModal(stavka)">
            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                >
                  <g>
                    <g>
                      <path
                        fill="#7b7b8a"
                        d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"
                      ></path>
                    </g>
                  </g>
                </svg>
          </div>
          <div class="add-napomena add-button remove-item" @click="popDeleteModal(stavka)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
            >
              <g>
                <g>
                  <path
                    fill="#70707E"
                    d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z"
                  />
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
      <!-- <div @click="editBreakdown(stavka.local_id)" :class="['row-number', chosen_id==stavka.local_id ? 'active':'']">{{stavka.local_id}} <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><g><g><path fill="#7b7b8a" d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"></path></g></g></svg></div>
                    <div class="fiksna-stavka">
                        <div class="st stavka-datum bd1">
                            <v-menu ref="menu1" v-model="stavka.date_picker_open" :close-on-content-click="false" transition="scale-transition" offset-y
                            max-width="290px" min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <input type="text" placeholder="dd.mm.yyyy" readonly :value="getDate(stavka.date)" v-bind="attrs"
                                @click="stavka.date_picker_open=true;" v-on="on">
                            </template>
                            <v-date-picker locale="hr" :first-day-of-week="1" v-model="stavka.date" no-title @input="stavka.date_picker_open=false;"></v-date-picker>
                            </v-menu>
                            
                        </div>
                        <div class="st breakdown-textarea bd2">{{service_types.find(s=>s.id == stavka.service_type_id).naziv+' - '+stavka.description}}</div>
                        <div class="st breakdown-textarea bd3a bolded">{{stavka.osobe.results_final.name}}</div>
                        <input class="st stavka-iznos bd3b bolded" disabled height="43px" :value="stavka.belonging_satnica_id" />    
                        <input type="text" class="st stavka-iznos bd4" v-model="stavka.satnica" @input="calculateIznos(stavka)" oninput="this.value = this.value.replace(',','.').replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');">
                        <div class="breakdown-time-wrapper bd5 st stavka-iznos">
                            <div class="time-wrapper">
                                <input type="number" min="0" v-model="stavka.time_h" @input="calculateIznos(stavka)">
                                <span> h</span>
                            </div>
                            <div class="time-wrapper">
                                <input type="number" min="0" max="59" v-model="stavka.time_min" @input="calculateIznos(stavka)">
                                <span> min</span>
                            </div>
                        </div>
                        <input type="text" disabled class="st stavka-iznos bd6" v-model="stavka.iznos">
                    </div>
                    <div class="add-napomena add-button remove-item" @click="deleteStavka(stavka)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                            <g><g><path fill="#70707E" d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z" /></g></g>
                        </svg>
                    </div>-->
      <div class="add-new" @click="newPurchase">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xmlns:avocode="https://avocode.com/"
          id="SVGDoc"
          width="12"
          height="12"
          version="1.1"
          viewBox="0 0 12 12"
        >
          <defs />
          <desc>Generated with Avocode.</desc>
          <g>
            <g>
              <title>Shape 544</title>
              <path
                d="M10.88006,4.71948c-0.14734,-0.14586 -0.32628,-0.2183 -0.5368,-0.2183h-3.28338v0v-3.24824c0,-0.20795 -0.07367,-0.38519 -0.22101,-0.53089c-0.14722,-0.1457 -0.32604,-0.21863 -0.5368,-0.21863h-1.51527c-0.21052,0 -0.38934,0.07293 -0.53668,0.21863c-0.14734,0.1457 -0.22101,0.32294 -0.22101,0.53089v3.24824v0h-3.28338c-0.2104,0 -0.38934,0.07243 -0.53668,0.2183c-0.14746,0.14603 -0.22101,0.3226 -0.22101,0.53072v1.4992c0,0.20828 0.07355,0.38536 0.22101,0.53105c0.14734,0.1457 0.32628,0.21846 0.53668,0.21846h3.28326v0v3.2479c0,0.20812 0.07379,0.38536 0.22113,0.53105c0.14734,0.1457 0.32616,0.2183 0.53668,0.2183h1.51539c0.21064,0 0.38934,-0.0726 0.53668,-0.2183c0.14746,-0.1457 0.22113,-0.32294 0.22113,-0.53105v-3.2479v0h3.28326c0.21064,0 0.38958,-0.07277 0.5368,-0.21846c0.14734,-0.1457 0.22101,-0.32277 0.22101,-0.53105v-1.4992c0,-0.20812 -0.07367,-0.38502 -0.22101,-0.53072z"
                fill="#7b7b8a"
                fill-opacity="1"
              />
            </g>
          </g>
        </svg>
        <span>{{ $t("forms.cost_sheet.breakdown.add") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery"
export default {
  name: "PurchaseTable",
  props: {
    stavke: Array,
  },
  data(){
    return {
      delete_modal : false,
      selected_for_delete : null
    }
  },
  methods: {
    popEditModal(stavka)
    {
        this.$emit("selectEdit", stavka)
    },
    popDeleteModal(stavka)
    {
      this.selected_for_delete = stavka;
      this.delete_modal = true;

    }, 
    deleteRow()
    {
      this.$emit("delete", this.selected_for_delete.id)
      this.selected_for_delete = null;
      this.delete_modal = false
    },  
    purchaseValSwitch(stavka, key)
    {
        // $("#purchase-checkbox-"+comp_id).toggleClass("active")
        this.stavke[key].aquired = !this.stavke[key].aquired
        this.$emit("updateState", {id:stavka.id, data:{aquired : stavka.aquired}})
        // this.purchase.aquired = !this.purchase.aquired
    },
    newPurchase() {
      this.$emit("newPurchase");
    },
  },
};
</script>

<style></style>
